import React from 'react';
import { grid } from 'ldrs';
import './Loading.css';  // Add this import

grid.register();

const Loading = () => (
    <div className="loading-wrapper">
        <l-grid size="100" speed="1.5" color="white"></l-grid>
    </div>
);

export default Loading;